import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import regeneratorRuntime from "/home/vsts/work/1/s/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import axios from "axios";
import * as jose from "jose";
import Cookies from "js-cookie";
import { DateTime } from "luxon";
import jwt from "jsonwebtoken";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var SESSA = "SESSa";
var SESSR = "SESSr";
var SESSS = "SESSs";
export var getAuthToken = function() {
    return __awaiter(void 0, void 0, void 0, regeneratorRuntime.mark(function _callee() {
        var accessToken, refreshToken, endpoint, ref, freshToken;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    accessToken = Cookies.get(SESSA);
                    if (!(accessToken && isAccessTokenExpired(accessToken))) {
                        _ctx.next = 10;
                        break;
                    }
                    refreshToken = Cookies.get(SESSR);
                    endpoint = "".concat(process.env.NEXT_PUBLIC_AUTH_URL, "/api/User/refresh-token");
                    _ctx.next = 6;
                    return axios.post(endpoint, JSON.stringify(refreshToken), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                case 6:
                    ref = _ctx.sent;
                    freshToken = ref.data;
                    if (!freshToken.success) {
                        logout();
                    }
                    if (freshToken) {
                        accessToken = freshToken.accessToken;
                        setToken(freshToken);
                    }
                case 10:
                    return _ctx.abrupt("return", accessToken);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
var PUBLIC_KEY = "-----BEGIN PUBLIC KEY-----\n".concat(process.env.NEXT_PUBLIC_FRONTEGG_JWT_PUBLIC_KEY, "\n-----END PUBLIC KEY-----");
var verifyJwt = function(token) {
    try {
        if (!PUBLIC_KEY) {
            console.error("Public key is not defined");
            return true;
        }
        jwt.verify(token, PUBLIC_KEY, {
            algorithms: [
                "RS256"
            ]
        });
        return true;
    } catch (error) {
        if (error.name === "TokenExpiredError") {
            return true;
        }
        return false;
    }
};
export var getCurrentUser = function() {
    var token = Cookies.get("SESSa");
    if (!token) {
        return null;
    }
    var isValid = verifyJwt(token);
    if (!isValid) {
        console.error("Invalid JWT token");
        return null;
    }
    var payload = jose.decodeJwt(token);
    if (payload) {
        return payload;
    }
    return null;
};
export var logout = function() {
    var domain = getDomain();
    Cookies.remove(SESSA, {
        path: "/",
        domain: domain
    });
    Cookies.remove(SESSR, {
        path: "/",
        domain: domain
    });
    Cookies.remove(SESSS, {
        path: "/",
        domain: domain
    });
};
export var getDomain = function() {
    if ("object" !== "undefined") {
        var res = "." + window.location.hostname.split(".").reverse().splice(0, 2).reverse().join(".") === process.env.NEXT_PUBLIC_BIOCENTURY_DOMAIN ? process.env.NEXT_PUBLIC_BIOCENTURY_DOMAIN : "." + window.location.hostname.split(".").reverse().splice(0, 2).reverse().join(".");
        return res;
    }
    return null;
};
export var setToken = function(token) {
    var domain = getDomain();
    var expires = new Date();
    expires.setUTCFullYear(expires.getUTCFullYear() + 2);
    Cookies.set("SESSa", token.accessToken, {
        path: "/",
        domain: domain,
        secure: true,
        expires: expires,
        sameSite: "None"
    });
    Cookies.set("SESSr", token.refreshToken, {
        path: "/",
        domain: domain,
        secure: true,
        expires: expires,
        sameSite: "None"
    });
};
export var isAccessTokenExpired = function(accessToken) {
    var JWT = jose.decodeJwt(accessToken);
    var now = DateTime.local().minus({
        minutes: 1
    });
    var expiration = DateTime.fromMillis(JWT.exp * 1000);
    return expiration <= now;
};
